import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom'

window.lightGallery = lightGallery;
window.lgZoom = lgZoom;

$(document).ready(function () {
    $('.js__light_gallery_photos').each(function () {
        lightGallery(this, {  // Просто передайте this, а не document.getElementById
            plugins: [lgZoom],
            speed: 500,
            selector: '.js__link_gallery',
            licenseKey: 'your_license_key'
        });
    });
});